/**
 * Created by wzf on 2018/4/23.
 */
export const m = {


}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js